/**
 * The `MyGlobalData` component creates a context provider with global data values for a React
 * application.
 * @returns The `MyGlobalData` component is being returned. It provides a context provider
 * `SettingContext.Provider` with the `globalData` object as the context value, and renders the
 * children components passed to it.
 */
import React from "react";
import dayjs from "dayjs";
import { SettingContext } from "./Context";
import Cookies from "js-cookie";

const MyGlobalData = ({ children }) => {
  let globalData = {
    URL: window.location.hostname,
    // API_URL: document.getElementById("API_URL").value,
    // API_URL: "http://localhost:3003",
    // API_URL: "https://api.test.rabsconnect.in",
    API_URL: "https://backend.dts.leadboat.in",
    // API_URL: "https://backend.dts-erp.com",
    // API_URL: "https://backend.durlax.rabs.support",
    variable: {
      DateTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    },
    CompanyName: window.location.hostname,
    Version: "0.5",
    currScreen: "",
    login: {
      path: React.lazy(() => import("../pages/Auth/Login/Login")),
    },
    register: {
      path: React.lazy(() => import("../pages/Auth/Register/Register")),
    },
    verifyotp: {
      path: React.lazy(() => import("../pages/Auth/VerifyOtp/VerifyOtp")),
    },
    forgetpassword: {
      path: React.lazy(() =>
        import("../pages/Auth/ForgotPassword/ForgotPassword")
      ),
    },
    module_privilege: "",
    user_data: "",
    data_array: [],
    pages: {
      components: {
        leftsidebar: React.lazy(() =>
          import("../components/Leftsidebar/Leftsidebar")
        ),
      },
      dashboard:React.lazy(() => import("../pages/Dashboard/Dashboard")),
      subdashboard: React.lazy(() => import("../pages/SubDashboard/SubDashboard")),
      somethingWentWrong:React.lazy(() => import("../pages/SomethingWentWrong/SomethingWentWrong")),
      forgotpassword: React.lazy(() =>
        import("../pages/Auth/ForgotPassword/ForgotPassword")
      ),
      changepassword: React.lazy(() =>
        import("../pages/Auth/ChangePassword/ChangePassword")
      ),
      employee: {
        addemployee: React.lazy(() => import("../pages/Employee/AddEmployee")),
        editemployee: React.lazy(() => import("../pages/Employee/EditEmployee")),
        viewemployee: React.lazy(() => import("../pages/Employee/ViewEmployee")),
        employeedetails: React.lazy(() => import("../pages/Employee/EmployeeDetails")),
      },
      customer: {
        addcustomer: React.lazy(() => import("../pages/Customers/AddCustomer")),
        editcustomer: React.lazy(() => import("../pages/Customers/EditCustomer")),
        viewcustomer: React.lazy(() => import("../pages/Customers/ViewCustomer")),
        customerdetails: React.lazy(() => import("../pages/Customers/CustomerDetails")),
      },
      customertype: {
        addcustomertype: React.lazy(() => import("../pages/CustomerTypes/AddCustomerType")),
        editcustomertype: React.lazy(() => import("../pages/CustomerTypes/EditCustomerType")),
        viewcustomertype: React.lazy(() => import("../pages/CustomerTypes/ViewCustomerType")),
        customertype: React.lazy(() => import("../pages/CustomerTypes/CustomerType")),
      },
      product: {
        addproduct: React.lazy(() => import("../pages/Products/AddProduct")),
        editproduct: React.lazy(() => import("../pages/Products/EditProduct")),
        viewproduct: React.lazy(() => import("../pages/Products/ViewProduct")),
        productdetails: React.lazy(() => import("../pages/Products/ProductDetails")),
      },
      productclientrates: {
        addproductclientrates: React.lazy(() => import("../pages/ProductClientRates/AddProductClientRates")),
        editproductclientrates: React.lazy(() => import("../pages/ProductClientRates/EditProductClientRates")),
        viewproductclientrates: React.lazy(() => import("../pages/ProductClientRates/ViewProductClientRates")),
        productclientrates: React.lazy(() => import("../pages/ProductClientRates/ProductClientRates")),
      },
      productbrand: {
        addproductbrand: React.lazy(() => import("../pages/ProductBrands/AddProductBrand")),
        editproductbrand: React.lazy(() => import("../pages/ProductBrands/EditProductBrand")),
        viewproductbrand: React.lazy(() => import("../pages/ProductBrands/ViewProductBrand")),
        productbrand: React.lazy(() => import("../pages/ProductBrands/ProductBrand")),
      },
      sizeunits: {
        addsizeunit: React.lazy(() => import("../pages/SizeUnits/AddSizeUnits")),
        editsizeunit: React.lazy(() => import("../pages/SizeUnits/EditSizeUnits")),
        viewsizeunit: React.lazy(() => import("../pages/SizeUnits/ViewSizeUnits")),
        sizeunits: React.lazy(() => import("../pages/SizeUnits/SizeUnits")),
      },
      hsncode: {
        addhsncode: React.lazy(() => import("../pages/HSNcode/AddHsnCode")),
        edithsncode: React.lazy(() => import("../pages/HSNcode/EditHsnCode")),
        viewhsncode: React.lazy(() => import("../pages/HSNcode/ViewHsnCode")),
        hsncode: React.lazy(() => import("../pages/HSNcode/HsnCode")),
      },
      user: {
        adduser: React.lazy(() => import("../pages/Users/AddUser")),
        userdetails: React.lazy(() => import("../pages/Users/UserDetails")),
        edituser: React.lazy(() => import("../pages/Users/EditUser")),
        viewuser: React.lazy(() => import("../pages/Users/ViewUser")),
      },
      requirement: {
        addrequirement: React.lazy(() => import("../pages/Requirement/AddRequirement.js")),
        requirementdetails: React.lazy(() => import("../pages/Requirement/RequirementDetails.js")),
        editrequirement: React.lazy(() => import("../pages/Requirement/EditRequirement.js")),
        quickeditrequirement: React.lazy(() => import("../pages/Requirement/QuickEditRequirement.js")),
        editrequirementproduct: React.lazy(() => import("../pages/Requirement/EditRequirementProduct.js")),
        viewrequirement: React.lazy(() => import("../pages/Requirement/ViewRequirement.js")),
      },
      invoice: {
        editinvoice: React.lazy(() => import("../pages/Invoice/EditInvoice")),
        invoicedetails: React.lazy(() => import("../pages/Invoice/InvoiceDetails")),
        viewinvoice: React.lazy(() => import("../pages/Invoice/ViewInvoice")),
        taxinvoicedetails: React.lazy(() => import("../pages/Invoice/TaxInvoiceDetails")),
        edittaxinvoice: React.lazy(() => import("../pages/Invoice/EditTaxInvoice")),
        quickedittaxinvoice: React.lazy(() => import("../pages/Invoice/QuickEditTaxInvoice")),
        viewtaxinvoice: React.lazy(() => import("../pages/Invoice/ViewTaxInvoice")),
        viewchallaninvoice: React.lazy(() => import("../pages/Invoice/ViewChallanInvoice")),
      },
      einvoice: {
        einvoicedetails: React.lazy(() => import("../pages/EInvoice/EInvoiceDetails")),
        generateirn: React.lazy(() => import("../pages/EInvoice/GenerateIRN")),
        cancelirn: React.lazy(() => import("../pages/EInvoice/CancelIRN")),
        vieweinvoice: React.lazy(() => import("../pages/EInvoice/ViewEInvoice")),
        einvoiceprint: React.lazy(() => import("../pages/EInvoice/EInvoicePrint")),
        generateewaybill: React.lazy(() => import("../pages/EInvoice/GenerateEWayBill")),
        viewewaybill: React.lazy(() => import("../pages/EInvoice/ViewEWayBill")),
      },
      gstno: {
        addgstno: React.lazy(() => import("../pages/GSTNo/AddGSTNo")),
        editgstno: React.lazy(() => import("../pages/GSTNo/EditGSTNo")),
        viewgstno: React.lazy(() => import("../pages/GSTNo/ViewGSTNo")),
        gstnodetails: React.lazy(() => import("../pages/GSTNo/GSTNo")),
      },
      invoicecharges: {
        addinvoicecharges: React.lazy(() => import("../pages/InvoiceCharges/AddInvoiceCharges")),
        editinvoicecharges: React.lazy(() => import("../pages/InvoiceCharges/EditInvoiceCharges")),
        viewinvoicecharges: React.lazy(() => import("../pages/InvoiceCharges/ViewInvoiceCharges")),
        invoicechargesdetails: React.lazy(() => import("../pages/InvoiceCharges/InvoiceChargesDetails")),
      },
      bankaccount: {
        addbankaccount: React.lazy(() => import("../pages/BankAccount/AddBankAccount")),
        editbankaccount: React.lazy(() => import("../pages/BankAccount/EditBankAccount")),
        viewbankaccount: React.lazy(() => import("../pages/BankAccount/ViewBankAccount")),
        bankaccounts: React.lazy(() => import("../pages/BankAccount/BankAccounts")),
      },
      purchaseorder: {
        purchaseorderdetails: React.lazy(() => import("../pages/PurchaseOrder/PurchaseOrderDetails")),
        addpurchaseorder: React.lazy(()=> import("../pages/PurchaseOrder/AddPurchaseOrder")),
        editpurchaseorder: React.lazy(()=> import("../pages/PurchaseOrder/EditPurchaseOrder")),
        viewpurchaseorder: React.lazy(()=> import("../pages/PurchaseOrder/ViewPurchaseOrder")),
      },
      samplekits: {
        samplekitsdetails: React.lazy(() => import("../pages/SampleKits/SampleKitsDetails")),
        addsamplekits: React.lazy(()=> import("../pages/SampleKits/AddSampleKits")),
        editsamplekits: React.lazy(()=> import("../pages/SampleKits/EditSampleKits")),
        viewsamplekits: React.lazy(()=> import("../pages/SampleKits/ViewSampleKits")),
      },
      samples: {
        samplesdetails: React.lazy(() => import("../pages/Samples/SamplesDetails")),
        addsamples: React.lazy(()=> import("../pages/Samples/AddSamples")),
        editsamples: React.lazy(()=> import("../pages/Samples/EditSamples")),
        viewsamples: React.lazy(()=> import("../pages/Samples/ViewSamples")),
      },
      inventory: {
        inventorydetails: React.lazy(() => import("../pages/Inventory/InventoryDetails")),
        addinventory: React.lazy(()=> import("../pages/Inventory/AddInventory")),
        editinventory: React.lazy(()=> import("../pages/Inventory/EditInventory")),
        viewinventory: React.lazy(()=> import("../pages/Inventory/ViewInventory")),
      },
      audit:{
        auditdetails: React.lazy(() => import("../pages/Audit/AuditDetails")),
      },
      report: {
        productreport: React.lazy(() => import("../pages/Report/ProductReport")),
      },
      email: {
        templates: React.lazy(() => import("../pages/email/templates")),
      },
      other: {
        loader: React.lazy(() => import("../pages/Other/Loader")),
        profile: React.lazy(() => import("../pages/Other/Profile/Profile")),
      },
    },
  };

  return (
    <SettingContext.Provider value={{ globalData }}>
      {children}
    </SettingContext.Provider>
  );
};

export default MyGlobalData;
